<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right"></div>
      <h4 class="page-title">Teenuste raport</h4>
    </div>

    <div class="card">
      <div class="card-body bg-light pb-1">

        <b-form novalidate @submit.prevent="submit">
          <b-form-row>
            <div class="form-group col-4 d-flex flex-column justify-content-between">
              <date-range-picker v-model="filter.dateRange" placeholder="Tänased"
                                 class="input-group-sm mb-2" :class="{'form-control-highlighted': dirtyDateRange()}"/>

              <b-form-checkbox v-model="hideDetails" :unchecked-value="false">
                Peida teenuste read
              </b-form-checkbox>

              <div>
                {{clientName}}
              </div>
            </div>
            <div class="form-group col-3">
              <b-form-select multiple :select-size="8" v-model="filter.objects" :options="objects"
                             value-field="code" text-field="label" size="sm" :class="{'form-control-highlighted': dirty('objects')}"/>
            </div>
            <div class="form-group col-3">
              <b-form-select multiple :select-size="8" v-model="filter.serviceGroups" :options="serviceGroups"
                             value-field="id" text-field="name" size="sm" :class="{'form-control-highlighted': dirty('serviceGroups')}"/>
            </div>
            <div class="form-group col-2 text-right d-flex flex-column justify-content-between">

              <button type="submit" class="btn btn-primary float-right" :disabled="processing">
                <i v-if="processing" class="mdi mdi-loading mdi-spin"></i>
                Koosta raport
              </button>
              <a @click="resetFilter" class="reset-filter text-secondary"><span class="mdi mdi-filter-remove"></span> Algseis</a>
            </div>
          </b-form-row>
        </b-form>
      </div>

      <div class="card-body" v-if="report">

        <template v-if="Object.keys(report.clientServiceReports).length">

          <div class="mb-2 d-flex justify-content-between">
            <span>Kokku {{Object.keys(report.clientServiceReports).length}} klienti</span>
            <a target="_blank" :href="`/api/reports/service-report/xls?${exportParams}`" title="Ekspordi Excelisse"><i class="mdi mdi-download mr-1"></i>
              Ekspordi Excelisse
            </a>
          </div>

          <table v-if="!hideDetails" class="table table-centered table-sm table-hover table-expandable table-sticky">
            <thead>
            <tr>
              <th>Kliendinimi</th>
              <th>Teenuse nimi</th>
              <th v-for="object in report.objects" class="text-right">{{object}}</th>
            </tr>
            </thead>
            <template v-for="client in report.clientServiceReports">
              <tr class="headline-row">
                <th :colspan="2 + report.objects.length">{{client.clientName}}</th>
              </tr>

              <tr v-for="(service, name) in client.serviceAmountsByObject">
                <td></td>
                <td>
                  {{name}}
                </td>
                <td v-for="object in report.objects" class="text-right">
                  {{service[object] | amount}}
                </td>
              </tr>
              <tr>
                <td></td>
                <th>Kokku</th>
                <th v-for="object in report.objects" class="text-right">
                  {{client.totalsByObjects[object] | amount}}
                </th>
              </tr>
            </template>

            <tr>
              <td></td>
              <th>Kõik Kokku</th>
              <th v-for="object in report.objects" class="text-right">
                {{report.totalsByObjects[object] | amount}}
              </th>
            </tr>
          </table>

          <table v-else class="table table-centered table-sm table-hover table-expandable table-sticky">
            <thead>
            <tr>
              <th>Kliendinimi</th>
              <th v-for="object in report.objects" class="text-right">{{object}}</th>
            </tr>
            </thead>
            <template v-for="client in report.clientServiceReports">
              <tr>
                <th>{{client.clientName}}</th>
                <td v-for="object in report.objects" class="text-right">
                  {{client.totalsByObjects[object] | amount}}
                </td>
              </tr>
            </template>
            <tr>
              <th>Kõik Kokku</th>
              <th v-for="object in report.objects" class="text-right">
                {{report.totalsByObjects[object] | amount}}
              </th>
            </tr>
          </table>
        </template>

        <div v-else class="text-center alert alert-info alert-card-edge-to-edge mt-2">
          Teenuseid ei leitud
        </div>
      </div>

      <div v-else class="text-center my-3">
        Valige kriteeriumid ja käivitage raport
      </div>
    </div>

  </div>
</template>

<script>
  import DateRangePicker from '../components/DateRangePicker'
  import SearchFilterMixin from '../mixins/SearchFilterMixin'
  import QueryParamsMixin from '../mixins/QueryParamsMixin'

  export default {
    mixins: [SearchFilterMixin, QueryParamsMixin],
    components: {DateRangePicker},
    data() {
      return {
        defaultFilter: {
          objects: [],
          serviceGroups: [],
        },
        filter: {},
        objects: [],
        serviceGroups: [],
        processing: false,
        report: null,
        hideDetails: false
      }
    },
    methods: {
      submit() {
        this.processing = true

        this.$gateway.post('/reports/service-report', {
            serviceGroups: this.filter.serviceGroups,
            objects: this.filter.objects,
            from: this.filter.dateRange.from,
            until: this.filter.dateRange.until,
            clientId: this.filter.clientId
          }
        ).then(r => {
          this.report = r.data
          this.processing = false
        }).catch(() => {
          this.processing = false
        })
      },
    },
    computed: {
      exportParams() {
        return this.queryParams({
          serviceGroups: this.filter.serviceGroups,
          objects: this.filter.objects,
          from: this.filter.dateRange.from,
          until: this.filter.dateRange.until,
          clientId: this.filter.clientId
        });
      },
      clientName() {
        return this.$store.state.client ? this.$store.state.client.name : ''
      }
    },
    created() {
      this.$gateway.get('/configuration/invoice-prefixes').then(r => this.objects = r.data)
      this.$gateway.get('/provided-service-groups').then(r => this.serviceGroups = r.data)
    }
  }
</script>
